<template>
  <div>  

    <tabs class="campaigns" type="boxed" size="normal" :active-index="activeTabIndex" :key="activeTabIndex" :on-tab-click="selectTab">

      <tab-item :label="$t('AKTUELLE AKTIONEN')">
        <pim-campaigns-table v-if="activeTab === 'current'" :isArchive="false" :embeddedView="embeddedView" :givenSiteId="siteId"></pim-campaigns-table>
      </tab-item>
      
      <tab-item :label="$t('ABGELAUFENE AKTIONEN')">
        <pim-campaigns-table v-if="activeTab === 'archive'" isArchive :embeddedView="embeddedView" :givenSiteId="siteId"></pim-campaigns-table>
      </tab-item>

      <tab-item :label="$t('EINSTELLUNGEN')" v-if="activeUserSite && siteId != null">

        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

          <div
            style="justify-content: space-between"
            class="control erpOffersSelector"
            v-if="siteId != null && activeUserSite && activeUserSite.erp && activeUserSite.erp != ''"
          >
            <div class="control-label">
              <label-name labelKey="SITE-APOPOINT-ERP-USE_OFFERS"></label-name>
            </div>
            <div style="display: flex; align-items: center">
              <b-switch
                v-model="useErpOffers"
                type="primary"
                size="small"
                @input="updateSite"
              ></b-switch>
            </div>
          </div>


          <template v-if="this.offerSettings && this.offerSettings.autoApplyHerbaOffers">

            <h3 class="titlelist"><lang labelKey="PIM-CAMPAIGN-CATEGORY-PROMOTION-HEADING"></lang></h3>

            <div style="justify-content: space-between" class="erpOffersSelector" v-for="label in settingsOfferCategories" :key="label">
              <div class="control-label">
                <label-name
                  :labelKey="'PIM-CAMPAIGN-CATEGORY-PROMOTION-' + label.name"
                ></label-name>
              </div>
              <div style="display: flex; align-items: center">
                
                <b-switch
                  v-model="offerSettings.autoApplyHerbaOffers[label.name]"
                  type="primary"
                  size="small"
                  @input="updateTable()"
                ></b-switch>
      
              </div>
            </div>

          </template>

        </template>
      </tab-item>

    </tabs>

    <!-- MODAL -->
    <modal
      :title="modal.title"
      transition="fadeDown"
      :is-show="showModal"
      :backdrop-closable="false"
      :show-footer="true"
      @close="closeModal"
      :class="['vcenter', modal.class]"
    >
      <template v-if="modal.type == 'campaignNew'">
        <div style="width: 450px; margin: 0 auto">
          <div class="control wide">
            <div class="control-label">
              <lang labelKey="PIM-CAMPAIGNS-TYPE" class="label"></lang>
            </div>

            <div class="control">
              <multiselect
                v-model="newCampaign.type"
                :options="Object.values(campaignTypes)"
                :custom-label="customLabel"
                :allow-empty="false"
                selected-label="aktiv"
                deselect-label="Klick um abzuwählen"
                select-label="Klick für Auswahl"
                placeholder="Bitte Typ auswählen"
                label="name"
                track-by="id"
                :optionsLimit="10"
                style="margin-bottom: 15px; max-width: 450px"
                class="small"
              >
                <span slot="noResult"
                  >Ihre Suche ergab leider keine Treffer.</span
                >
              </multiselect>
            </div>
          </div>

          <!-- <form-input label="name" inputType="text" v-model="newCampaign.name"></form-input> -->
          <form-input
            label="PIM-CAMPAIGNS-TYPE-DESCRIPTION"
            inputType="textarea"
            v-model="newCampaign.description"
          ></form-input>
        </div>

        <template slot="footer">
          <a class="button" @click="closeModal">Abbrechen</a>
          <a
            :class="[
              'button is-primary',
              { 'is-loading': modal.isSaving, 'is-disabled': mandatoryFields },
            ]"
            @click="campaignCreate"
            >Anlegen</a
          >
        </template>
      </template>

    </modal>
  </div>
</template>



<script>
import Vue from "vue";

import { ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable, {}, false, "bulma");

import Multiselect from "vue-multiselect";
import pimCampaignsTable from "./incl-pimCampaignsTable.vue";

export default {
  name: "pimCampaigns",

  components: {
    Multiselect,
    pimCampaignsTable
  },

  props: {
    embeddedView: {
      type: Boolean,
      default: false
    },
    isArchive: {
      type: Boolean,
      default: false
    },
    openNewCampaignModal: {
      type: Boolean,
      default: false,
    },
    givenSiteId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      activeTab: 'current',
      useErpOffers: false,
      offerSettings: {
        autoApplyHerbaOffers: {}
      },

      isLoading: false,
      isRefetching: false,

      allMarked: false,
      markedRows: [],

      campaigns: [],
      campaignSelected: null,

      site: null,

      newCampaign: {
        name: null,
        type: null,
        description: null,
      },

      modal: {
        isSaving: false,
        isLoading: false,
        title: "",
        type: null,
        class: "",
      },

      showModal: false,
      initDone: false
    };
  },

  computed: {

    activeTabIndex() {
      return this.tabs.findIndex((tab) => tab == this.activeTab);
    },

    tabs() {
      return ['current', 'archive', 'settings'];
    },

    offerCategories() {
      return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_CATEGORY");
    },

    settingsOfferCategories() {
      return Object.values(this.offerCategories).filter((v) => ['APOKAT', 'APOTUETE', 'OTHER'].includes(v.name));
    },

    filteredCampaigns() {
      return this.campaigns;
    },

    isFilterActive() {
      for (let key in this.filters) {
        if (this.filters[key].isActive == true) {
          return true;
        }
      }

      return false;
    },

    mandatoryFields() {
      return (
        this.newCampaign.type == null ||
        this.newCampaign.description == null ||
        this.newCampaign.description == ""
      );
      // return this.newCampaign.type == null || this.newCampaign.name == null || this.newCampaign.name == '';
    },

    campaignTypes() {
      return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_TYPE");
    },

    campaignTypesArr() {
      return Object.values(this.campaignTypes);
    },

    campaignStatus() {
      return this.$store.getters.getTermsByTaxonomy("APOPOINT_OFFER_STATUS");
    },

    siteId() {
      return this.givenSiteId != null
        ? this.givenSiteId
        : this.activeUserSite == null
          ? null
          : this.activeUserSite.id;
    },

    activeUserSite() {
      return this.activeUser.site == null ? null : this.activeUser.site;
    }

  },

  created() {

    // init offerSettings
    if(this.activeUserSite && this.activeUserSite.offerSettings && this.activeUserSite.offerSettings.autoApplyHerbaOffers) {
      this.offerSettings.autoApplyHerbaOffers = this.activeUserSite.offerSettings.autoApplyHerbaOffers;
    } else {
      this.offerSettings.autoApplyHerbaOffers = {};
      this.settingsOfferCategories.forEach((category) => {
        this.offerSettings.autoApplyHerbaOffers[category.name] = false;
      });
    }


  },

  mounted() {

    const savedTab = localStorage.getItem('lastCampaignsTab');
    const tabFromHash = window.location.hash.replace('#', '');
    const tab = this.tabs.includes(tabFromHash) ? tabFromHash : savedTab || 'current';
    
    this.activeTab = tab;

    setTimeout(() => {
      this.initDone = true;
    }, 50);

  },

  beforeDestroy() {
    localStorage.removeItem('lastCampaignsTab');
  },

  watch: {

    openNewCampaignModal(newValue, oldValue) {
      this.campaignNew();
    },

  },

  methods: {

    selectTab(index) {

      if(this.initDone) {
        this.activeTab = this.tabs[index];
        localStorage.setItem('lastCampaignsTab', this.activeTab);
        history.replaceState(null, '', `#${this.activeTab}`);
      }

    },

    updateTable(val) {
      this.axios
        .put(this.$config.api + "site/" + this.siteId, {
          offerSettings: this.offerSettings,
        })
        .then((res) => {
          this.$store.commit("setUser", {
            ...this.activeUser,
            ...{ site: res.data },
          });
        });
    },

    updateSite(val) {
      this.axios
        .put(this.$config.api + "site/" + this.siteId, {
          useErpOffers: this.useErpOffers,
        })
        .then((res) => {
          this.$store.commit("setUser", {
            ...this.activeUser,
            ...{ site: res.data },
          });
        });
    },


    customLabel({ name }) {
      return this.$t("PIM-CAMPAIGNS-TYPE-" + name);
    },

    campaignNew() {
        this.modal.title = this.$t("PIM-CAMPAIGNS-NEW_CAMPAIGN");
        this.modal.type = "campaignNew";
        this.showModal = true;
    },

    campaignCreate() {
      if (this.newCampaign.type == null) {
        this.$notify.open({
          content: "Bitte wählen Sie einen Typ aus!",
          type: "warning",
        });
        return;
      }
      if (this.newCampaign.description == null) {
        this.$notify.open({
          content: "Bitte geben Sie eine Beschreibung ein!",
          type: "warning",
        });
        return;
      }

      this.modal.isSaving = true;

      let saveData = {
        description: this.newCampaign.description,
        type: this.newCampaign.type,
        status: this.campaignStatus.DRAFT,
        site: this.activeUser.site == null ? null : this.activeUser.site.id,
      };

      this.axios
        .post(this.$config.api + "apopointOffer", saveData)
        .then((res) => {
          this.modal.isSaving = false;
          this.$router.push({
            name: "pimCampaignsDetail",
            params: { id: res.data.id },
          });
        });
    },


    closeModal() {
      this.showModal = false;
      this.modal.class = null;
      this.modal.type = null;
      this.modal.title = "";

      this.campaignSelected = null;

      this.newCampaign = {
        name: null,
        type: null,
        description: null,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~../../../assets/css/variables.scss";
@import "~pretty-checkbox/src/pretty-checkbox.scss";


.showTabApopoint {

  .tabs.campaigns {
    ::v-deep .tab-list {
      background-color: #f5f5f5;
      li {
        a {
          display: block !important;
          border-radius: 0 !important;
          &:hover {
            background-color: rgba(71, 84, 101, 0.7411764706) !important;
            color: #fff !important;
          }
        }
        &.is-active a {
          background-color: #475465 !important;
         color: #fff !important;
        }
      }
    }
  }
}

.p-default {
  margin: 0;
}

.erpOffersSelector {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 2px;
  padding: 18px;
  .control-label {
    max-width: 280px;
  }
}

.modal {
  &.preview {
    ::v-deep .modal-card {
      max-width: 640px;
      width: 100%;
      overflow: hidden;

      .modal-card-body {
        position: relative;

        h1 {
          font-weight: bold;
          margin-bottom: 24px;
        }

        .section {
          margin: 0 0 12px 0;
          padding: 0;

          label {
            display: block;
            text-transform: uppercase;
            font-size: 10px;
          }
        }

        ul.pimProducts {
          margin-left: 16px;
          list-style: disc;
          li {
            padding-left: 6px;
            padding-bottom: 4px;

            .subline {
              font-size: 12px;
              color: #AAA;
            }
          }
        }
        .divider {
          display: block;
          margin: 8px 0 20px 0;
          border-bottom: 2px solid #f5f7f9;
        }
      }
    }
  }
}

::v-deep .VueTables__table {
  td.takeOver {
    text-align: right;
    width: 55px;
    max-width: 55px;
  }

  td.actions {
    text-align: right;
    width: 140px;
    max-width: 140px;

    .button {
      .icon {
        margin: 0 !important;
        font-size: 12px;
      }
      &:not(:first-child) {
        margin-left: 2px;
      }
    }
  }
}
.titlelist {
  font-size: large;
  font-weight: 300;
  font-size: 16px;
  margin-bottom: 6px;
}
.filterBox {
  border: none;
  border-top: 1px solid #eaeaea;
  transition: all 0.3s ease;
  padding: 0;
  margin-bottom: 15px;

  legend {
    margin-left: 20px;
    text-transform: uppercase;
    padding: 0 5px;
    font-size: 13px;
    cursor: pointer;
  }

  .filterWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 0 10px 0;
  }

  &.active {
    border: 1px solid #eaeaea;
    border-radius: 4px;
    background: #fff;
    > .filterWrapper {
      margin: 6px 10px;
    }
  }
}
</style>
